// utils/eventFormDateTime.js
// Pure helpers for the Create/Edit Event form's string fields:
//   date = "MM/DD/YYYY" (zero-padded), time = "h:mm AM/PM" (hour unpadded).
// The submit handlers parse these strings, so the formats must not change.
// The time string is formatted with timeLabel (utils/eventDateParts.js).

const pad2 = (n) => String(n).padStart(2, "0");

export function formatFormDate(date) {
  return `${pad2(date.getMonth() + 1)}/${pad2(date.getDate())}/${date.getFullYear()}`;
}

export function parseFormDate(str) {
  const m = /^\s*(\d{1,2})\/(\d{1,2})\/(\d{4})\s*$/.exec(str || "");
  if (!m) return null;
  const month = parseInt(m[1], 10);
  const day = parseInt(m[2], 10);
  const year = parseInt(m[3], 10);
  const d = new Date(year, month - 1, day);
  // Reject rollovers such as 02/31/2027.
  if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) {
    return null;
  }
  return d;
}

export function parseFormTime(str, base = new Date()) {
  const m = /^\s*(\d{1,2}):(\d{2})\s*(AM|PM)\s*$/i.exec(str || "");
  if (!m) return null;
  const hour = parseInt(m[1], 10);
  const minute = parseInt(m[2], 10);
  if (hour < 1 || hour > 12 || minute > 59) return null;
  const isPM = m[3].toUpperCase() === "PM";
  const d = new Date(base.getTime());
  d.setHours((hour % 12) + (isPM ? 12 : 0), minute, 0, 0);
  return d;
}

// The form's date + time strings as one Date (null when either is invalid) —
// what the create / edit submit handlers store as start_date.
export function parseEventDateTime(dateStr, timeStr) {
  const day = parseFormDate(dateStr);
  return day ? parseFormTime(timeStr, day) : null;
}
